module.exports={
  "Read more": "LÃ¦s mere",
  "Download image": "Hent billede",
  "Go to website": "GÃ¥ til hjemmesiden"
}
